import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#252525",
    borderRadius: "50%",
    position: "sticky",
    zIndex: theme.zIndex.normal,
    top: "calc(50% - 30px)",
    left: 0,
    cursor: "pointer",
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 150ms ease",
    'body[data-input-mode="gamepad"] &': {
      opacity: "0 !important",
      pointerEvents: "none !important",
    },
    [BreakPointTablet]: {
      display: "none",
    },
    [BreakPointMobile]: {
      display: "none",
    },
  },
  iconRight: {
    right: 0,
  },
}));
